module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/Payslips.ejs -->\n<div class="panel-body payroll-payslips">\n    <div class="row">\n        <div class="col-xs-6"></div>\n        <div class="col-xs-6 col-employee">\n            <div class="row">\n                <label class="col-xs-2 control-label employee text-right">\n                    Employee\n                </label>\n                <div class="col-xs-10">\n                    <select class="js-employee-select">\n                        ';
 payslips.forEach(function(payslip, key) { 
__p+='\n                            <option value="'+
((__t=( key ))==null?'':_.escape(__t))+
'">\n                                '+
((__t=( payslip.getEmployee().get('fullName') ))==null?'':_.escape(__t))+
'\n                            </option>\n                        ';
 }) 
__p+='\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="slick-wrapper">\n        <div class="payslip-slick-prev js-prev-slide">\n            <i class="fa fa-angle-left"></i>\n        </div>\n        <div class="payslip-slick-next js-next-slide">\n            <i class="fa fa-angle-right"></i>\n        </div>\n        <div class="js-slides invisible">\n            ';
 payslips.forEach(function(payslip) { 
__p+='\n                <div class="js-slide js-slide-'+
((__t=( payslip.id ))==null?'':_.escape(__t))+
'"></div>\n            ';
 }) 
__p+='\n        </div>\n    </div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/payroll/stepTwo/Payslips.ejs
// module id = 748
// module chunks = 1